export const SKILL_SLOT_MAX = 8;
export const SKILL_SLOT_UNLOCKED_DEFAULT = 3;

/** Max skills stored in the skill library (inventory), separate from hotbar slots. */
export const SKILL_LIBRARY_MAX = 10;
export const SKILL_LIBRARY_UNLOCKED_DEFAULT = 3;

export const SKILL_LIBRARY_SLOT_UNLOCK_CASH_PRICES = [150, 300, 500, 800, 1200] as const;
export const SKILL_LIBRARY_SLOT_CARD_SKU = "skill.library_slot_unlock.v1";
export const SKILL_CREATE_CARD_SKU = "skill.create_card.v1";
export const SKILL_CREATE_CARD_CASH_COST = 250;

/** Skill FX template — width 72px, height 144px per frame (taller than wide). */
export const SKILL_TEMPLATE_FRAME_WIDTH = 72;
export const SKILL_TEMPLATE_FRAME_HEIGHT = 144;
/** @deprecated Use SKILL_TEMPLATE_FRAME_WIDTH */
export const SKILL_TEMPLATE_FRAME_SIZE = SKILL_TEMPLATE_FRAME_WIDTH;
export const SKILL_DISPLAY_HEIGHT_PX = SKILL_TEMPLATE_FRAME_HEIGHT;

/** Matches HomeRoomScene player sprite target height. */
export const PLAYER_DISPLAY_HEIGHT_PX = 96;

export const SKILL_DEFAULT_COOLDOWN_MS = 30_000;
export const SKILL_DEFAULT_BUFF_DURATION_MS = 5_000;
/** In-game buff skill VFX opacity (50% = softer overlay on player). */
export const SKILL_BUFF_FX_ALPHA = 0.5;

/** Cash price per unlock (3→4, 4→5, …). First extra slot = 0 cash. */
export const SKILL_SLOT_UNLOCK_CASH_PRICES = [0, 100, 250, 500, 1000] as const;

export const SKILL_SLOT_CARD_SKU = "skill.slot_unlock_card.v1";

export const SKILL_COOLDOWN_CARD_SKU = "skill.cooldown_card.v1";
export const SKILL_COOLDOWN_CARD_CASH_COST = 200;
export const SKILL_COOLDOWN_SEC_PER_CARD = 0.1;
export const SKILL_COOLDOWN_CARD_REDUCTION_MS = 100;
/** Minimum skill cooldown after cooldown cards (0.1s). */
export const SKILL_COOLDOWN_MIN_MS = 100;
/** @deprecated Legacy saves only — no per-skill cap anymore. */
export const SKILL_COOLDOWN_CARD_MAX = 4;

/** Buff skills — AP budget for stat bonuses (same scale as character stats). */
export const SKILL_BUFF_BASE_AP = 20;
export const SKILL_AP_CARD_SKU = "skill.ap_card.v1";
export const SKILL_AP_CARD_CASH_COST = 200;
/** Extra AP budget per card applied to one buff skill. */
export const SKILL_AP_PER_CARD = 5;

/** Buff duration extension cards (+0.1s each when applied to one buff skill). */
export const SKILL_BUFF_DURATION_CARD_SKU = "skill.buff_duration_card.v1";
export const SKILL_BUFF_DURATION_CARD_CASH_COST = 200;
export const SKILL_BUFF_DURATION_SEC_PER_CARD = 0.1;
export const SKILL_BUFF_DURATION_MS_PER_CARD = 100;

/** AOE attack skills — visual + hit area width per card (+1%). */
export const SKILL_AOE_RANGE_CARD_SKU = "skill.aoe_range_card.v1";
export const SKILL_AOE_RANGE_CARD_CASH_COST = 200;
export const SKILL_AOE_RANGE_WIDTH_PER_CARD = 0.01;

export function skillSlotUnlockCashCost(unlockedSlots: number): number | null {
  if (unlockedSlots >= SKILL_SLOT_MAX) return null;
  if (unlockedSlots < SKILL_SLOT_UNLOCKED_DEFAULT) {
    return SKILL_SLOT_UNLOCK_CASH_PRICES[0];
  }
  const index = unlockedSlots - SKILL_SLOT_UNLOCKED_DEFAULT;
  return SKILL_SLOT_UNLOCK_CASH_PRICES[index] ?? null;
}

export function skillLibrarySlotUnlockCashCost(unlockedSlots: number): number | null {
  if (unlockedSlots >= SKILL_LIBRARY_MAX) return null;
  if (unlockedSlots < SKILL_LIBRARY_UNLOCKED_DEFAULT) {
    return SKILL_LIBRARY_SLOT_UNLOCK_CASH_PRICES[0];
  }
  const index = unlockedSlots - SKILL_LIBRARY_UNLOCKED_DEFAULT;
  return SKILL_LIBRARY_SLOT_UNLOCK_CASH_PRICES[index] ?? 1500;
}

export function skillCooldownMs(cooldownCardsPurchased: number): number {
  const cards = Math.max(0, Math.floor(cooldownCardsPurchased));
  return Math.max(
    SKILL_COOLDOWN_MIN_MS,
    SKILL_DEFAULT_COOLDOWN_MS - cards * SKILL_COOLDOWN_CARD_REDUCTION_MS,
  );
}

export function formatSkillCooldownSeconds(ms: number): string {
  const sec = ms / 1000;
  if (Math.abs(sec - Math.round(sec)) < 1e-6) {
    return String(Math.round(sec));
  }
  return sec.toFixed(1);
}
